<template>
  <div class="userInfo">
    <div class="userBox">
      <div class="user">
        <figure class="userImg">
          <van-image
            class="userImgIcon"
            :src="userData.UserHeadPhoto && imgUrlFilter(userData.UserHeadPhoto)"
            @click="imagePreview(userData.UserHeadPhoto)"
          >
            <template v-slot:error>
              <img class="userImgIcon" src="~assets/img/userManage/user_logo@2x.png" />
            </template>
          </van-image>
        </figure>
        <p class="userName" v-if="userData.NickName">{{ userData.NickName }}</p>
        <p class="userName" v-else @click="goEditName">
          {{ $t.userInterpret.editName }}
        </p>
      </div>

      <ul class="userFooter">
        <li class="itemBox" @click="goShareProduct">
          <div class="itemCount">{{ shopData.ShareProductCount }}</div>
          <p class="itemTitle">{{ $t.userInterpret.ShippingSource }}</p>
        </li>
        <li class="itemBox" @click="goSupplier">
          <div class="itemCount">{{ shopData.CustomerCount }}</div>
          <p class="itemTitle">{{ $t.userInterpret.MySupplier }}</p>
        </li>
        <li class="itemBox" @click="goAnalyze(1)">
          <div class="itemCount">{{ shopData.ShopOrderCount }}</div>
          <p class="itemTitle">{{ $t.userInterpret.ShopOrder }}</p>
        </li>
        <li class="itemBox" @click="goAnalyze(2)">
          <div class="itemCount">{{ shopData.Visitors }}</div>
          <p class="itemTitle">{{ $t.userInterpret.ShopVisitor }}</p>
        </li>
      </ul>
    </div>
    <figure class="message" @click="goMessage">
      <van-badge
        color="#ff5852"
        :content="userData.UnreadMessageCount ? userData.UnreadMessageCount : null"
      >
        <img class="setImg" src="~assets/img/store/icon_my_message@2x.png" />
      </van-badge>
    </figure>
    <figure class="set" @click="goSet">
      <img class="setImg" src="~assets/img/store/icon_my_setting@2x.png" />
    </figure>
  </div>
</template>
<script>
import Vue from "vue";
import { Image, Badge } from "vant";
Vue.use(Image).use(Badge);

export default {
  name: "UserInfo",
  props: {
    userData: {
      type: Object,
    },
    shopData: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  methods: {
    //预览图片
    imagePreview(image) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [image],
      });
    },
    goAnalyze(type) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "analyze",
        name: "analyze",
        query: [
          {
            name: "Type",
            value: type,
          },
        ],
      });
    },
    goSupplier() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "supplier",
        name: "supplier",
        query: [],
      });
    },
    goShareProduct() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "focus/shareProduct",
        name: "shareProduct",
        query: [],
      });
    },
    goEditName() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "user/editNickname",
        name: "EditNickname",
        query: [],
      });
    },
    goMessage() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "messages",
        name: "Messages",
        query: [],
      });
    },
    goSet() {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: false,
        path: "user/setUser",
        name: "setUser",
        query: [],
      });
    },
    imgUrlFilter(value) {
      // console.log(value.split("|")[0]);
      return this.$api.formatImageUrl(value);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/publicStyle.scss";
.userInfo {
  width: 100%;
  position: relative;
  background: linear-gradient(left, #25b9ff, #0090e6);
  .userBox {
    width: 100%;
    .user {
      @include publicFlex;
      width: 86.6%;
      margin: 0 auto;
      background-color: transparent;
      padding-top: 12%;
      padding-bottom: 8%;
      .userImg {
        @include divPublic;
        width: 62px;
        height: 62px;
        border-radius: 100%;
        ::v-deep .van-image__error {
          object-fit: cover;
          border-radius: 100%;
        }
        ::v-deep .van-image__img {
          object-fit: cover;
          border-radius: 100%;
        }
        .userImgIcon {
          //width: 100%;
          width: 62px;
          height: 62px;
          object-fit: cover;
          -webkit-object-fit: cover;
          border-radius: 100%;
        }
      }
      .userName {
        @include divPublic;
        color: #ffffff;
        font-weight: bold;
        margin-left: 20px;
        flex: 1;
        -webkit-flex: 1;
      }
    }
    .userFooter {
      width: 100%;
      padding-bottom: 3%;
      margin: 0 auto;
      color: #fff;
      @include publicFlex;
      justify-content: space-around;
      -webkit-justify-content: space-around;
      list-style: none;
      .itemBox {
        text-align: center;
        max-width: 33.3%;
        list-style: none;
        @include divPublic;
        .itemCount {
          margin: auto;
          display: inline-block;
        }
        .itemTitle {
          @include divPublic;
          margin-top: 10px;
          font-size: 13px;
        }
      }
    }
  }
  .message {
    @include divPublic;
    position: absolute;
    top: 20px;
    right: 60px;
    .setImg {
      width: 25px;
      height: 25px;
    }
    ::v-deep .van-badge {
      top: 5px !important;
      right: 0px !important;
      border: none !important;
      padding: 1px 2px 1px 1px;
    }
  }
  .set {
    @include divPublic;
    position: absolute;
    top: 20px;
    right: 20px;
    .setImg {
      width: 25px;
      height: 25px;
    }
  }
}
</style>
